<div *ngIf="consultation">
    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;" *ngIf="consultation['hasAnnonce'] === 'Y'">
        <mat-card-header class="titree">
            {{ 'Annonces' | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <app-table-commun-portail [data]="[consultation]" [page]="'listAnnoncesConsultationPortail'" (openDialogListAttachedFilesEvent)="openDialogListAttachedFiles($event)"></app-table-commun-portail>
        </mat-card-content>
    </mat-card>

    <div [ngStyle]="{'margin-top': (consultation['hasAnnonce'] === 'Y')? '4%':''}">
        <!-- <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
            <mat-card-header class="titree">
                {{ "general_information" | translate }}
            </mat-card-header>
            <mat-card-content class="card-content">

                <table mat-table [dataSource]="dataSource" style="width: 100%;">

                    <ng-container matColumnDef="label" sticky="true">
                        <td mat-cell *matCellDef="let row">{{ row.label  | translate }}</td>
                    </ng-container>

                    <ng-container [matColumnDef]="'column' + i" *ngFor="let column of data; let i = index">
                        <td mat-cell *matCellDef="let row"> {{ row['column' + i]  | customDate}} </td>
                    </ng-container>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </mat-card-content>
        </mat-card> -->
        <app-fiche-consultation [data]="data" [label]="'general_information'" [labels]="labels"
                                [dataColumns]="dataColumns" [dataColumnsAr]="dataColumns"
                                [dataColumnsEn]="dataColumns"
                                [langue]="getlang()"
        >
        </app-fiche-consultation>
    </div>
    <div class="mb-1" fxLayoutAlign="end end" style="margin-top: 1%;">
        <app-spinner-container>
            <button
                    (click)="reportHistoriqueDelai()"
                    color="primary"
                    mat-raised-button
            >
                <span translate>{{ "Historique report des délais" | translate }}</span>
            </button>
        </app-spinner-container>
    </div>

    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2);margin-top: 1%;">
        <mat-card-header class="titree">
            {{ "Informations sur la consultation" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">


            <table mat-table [dataSource]="dataSourceCons" style="width: 100%;">

                <ng-container matColumnDef="label" sticky="true">
                    <td mat-cell *matCellDef="let row">{{ row.label  | translate }}</td>
                </ng-container>

                <ng-container [matColumnDef]="'column' + i" *ngFor="let column of datacons; let i = index">
                    <td style="font-weight: bold;" mat-cell *matCellDef="let row"> {{ row['column' + i]  | translate  }} </td>
                </ng-container>

                <tr mat-row *matRowDef="let row; columns: displayedColumnsCons;"></tr>
            </table>
            <app-empty-list-container [list]="dataSource.data" [withoutBorder]="true"></app-empty-list-container>
        </mat-card-content>
    </mat-card>
    <mat-card appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">

        <mat-card-header class="titree">
            {{ "Informations par lot ou article" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">

            <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">

                <app-tabletree-shop [list]="datatree"></app-tabletree-shop>

            </div>
        </mat-card-content>
    </mat-card>

    <mat-card  appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2) ;margin-top: 4%;">
        <mat-card-header class="titree">
            {{ "Documents de la consultation" | translate }}
        </mat-card-header>
        <mat-card-content class="card-content">
            <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;">
                <app-details-listchahier-shop [id]="shopNo" ></app-details-listchahier-shop>
            </div>

        </mat-card-content>
    </mat-card>
    <br>
    <div align="right" *ngIf="current_lang=='fr'|| current_lang=='en'">
        <button color="primary" mat-raised-button class="mr-2" (click)="openFicheListSoumissionaires()"
                [disabled]="!checkFlags['Winner']">
            <span>{{ "Soumissionnaire(s) retenu(s)" | translate}}</span>
        </button>
        <button color="primary" mat-raised-button class="mr-2" (click)="openFicheResultatOuverture()"
                [disabled]="!checkFlags['Resultat']">
            <span>{{ "Résultat" | translate}}</span>
        </button>
        <button [routerLink]="['/portail/consultations']" mat-raised-button
                style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
    </div>
    <div style="float: left;" *ngIf="current_lang=='ar'">
        <button [routerLink]="['/portail/consultations']" mat-raised-button
                style="background-color:#3E90D0; color: white;">{{"Liste"|translate}}</button>
        <button color="primary" mat-raised-button class="mr-2" (click)="openFicheListSoumissionaires()"
                [disabled]="!checkFlags['Winner']">
            <span>{{ "Soumissionnaire(s) retenu(s)" | translate}}</span>
        </button>
        <button color="primary" mat-raised-button class="mr-2" (click)="openFicheResultatOuverture()"
                [disabled]="!checkFlags['Resultat']">
            <span>{{ "Résultat" | translate}}</span>
        </button>
    </div>

</div>
